// import { AttributeSplitNodeData } from 'modules/workflows/types';

export const isSetup = ({ field } /*: AttributeSplitNodeData */ = {}) => !!field;

/**
 * getTextSegments
 * @param {*} field
 */
export const getTextSegments = ({
  field,
} /*: AttributeSplitNodeData */ = {}) /*: TextSegments */ => ({
  nodeDescBottom: { segments: [[{ text: field || '' }]] },
});
